import { IHotelState } from '../reducers';
import { HotelModel } from '../models';
import { findById } from '../util/general';

export const selectedHotel = (state:IHotelState):HotelModel =>
  findById(state.selectedHotelId)(state.hotels);

export const hotels = (state:IHotelState):HotelModel[] => state.filteredHotels;